import { Spinner } from "components";
import React, { FC, ReactNode } from "react";

export interface ButtonProps
  extends React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  children?: ReactNode;
  spinnerColor?: string;
  isLoading?: boolean;
  CClassName?: string | undefined;
}
const Btn: FC<ButtonProps> = ({
  isLoading,
  CClassName,
  spinnerColor = "white",
  children,
  ...otherProps
}) => {
  return (
    <button
      className={`${
        CClassName && CClassName
      } flex items-center justify-center rounded ring-blue-500 transition-all`}
      {...otherProps}
    >
      {isLoading ? (
        <div className="flex w-full justify-center">
          <Spinner fill={spinnerColor} />
        </div>
      ) : (
        children
      )}
    </button>
  );
};

export default Btn;
